import { render, staticRenderFns } from "./CertificationList.vue?vue&type=template&id=00d69ea0&scoped=true&"
import script from "./CertificationList.vue?vue&type=script&lang=js&"
export * from "./CertificationList.vue?vue&type=script&lang=js&"
import style0 from "./CertificationList.vue?vue&type=style&index=0&id=00d69ea0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d69ea0",
  null
  
)

export default component.exports